import { render, staticRenderFns } from "./customerServiceManagement.vue?vue&type=template&id=2adfa890&scoped=true&"
import script from "./customerServiceManagement.vue?vue&type=script&lang=js&"
export * from "./customerServiceManagement.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceManagement.vue?vue&type=style&index=0&id=2adfa890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adfa890",
  null
  
)

export default component.exports